import { CreatorGrowthLoopInputs } from '../loop/creator-growth-loop';
import { FeedImpactOutcome } from '../loop/feed-impact.model';

/** Contract for updating feed impact inputs after an event is mapped. */
export interface FeedImpactUpdate {
  creatorId: string;
  outcome: FeedImpactOutcome;
  growthLoopInput: keyof CreatorGrowthLoopInputs;
  /** Conceptual delta applied to the growth loop input accumulator. */
  delta: number;
}
